<template>
    <div class="home-page">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 col-md-6">
                    <video controls>
                        <source src="static/video/2024-Compliance-Portal-Message.mp4#t=03" type="video/mp4">
                    </video>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="news-sections">
                        <p class="news-title">news & announcements</p>
                        <template v-if="news.totalRecords > 0">
                            <div v-for="(newsItem, index) in news.row" :key="index" class="news-menu">
                                <div class="me-3">
                                    <!-- Check if newsItem has images and if the first image exists -->
                                    <template v-if="newsItem.image && newsItem.image.length > 0 && newsItem.image[0].image">
                                        <img v-for="image in newsItem.image" :key="image.id" :src="image.image" :alt="'News Image ' + image.id" />
                                    </template>
                                    <!-- Default image if no image is provided -->
                                    <template v-else>
                                        <img class="row-image" src="/static/images/default_news.png" alt="Default News Image" />
                                    </template>
                                </div>
                                <div style="flex:1;">
                                    <!-- News title with a link -->
                                    <a :href="`/news/${newsItem.slug}`">
                                        <span>{{ newsItem.title }}</span>
                                    </a>
                                    <!-- News date -->
                                    <p>{{ newsItem.news_date }}</p>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="fs-4 p-4 text-center">
                                No News
                            </div>
                        </template>
                    </div>
                    <div class="more-news" v-if="news.totalRecords > 0">
                        <router-link v-bind:to="{name: 'NewsAnnouncements'}">View more news and announcements ></router-link>
                    </div>
                </div>
            </div>
            <div class="events-detalis">
                <div class="row">
                    <div class="col-lg-8 col-md-6">
                        <div class="events-box">
                            <p class="event-title">upcoming events & deadlines</p>
                            <div v-if="events.totalRecords > 0" class="row">
                                <div class="col-md-8 offset-md-2">
                                    <div class="row">
                                        <!-- Loop through only the 6 events to be displayed -->
                                        <div v-for="(event, index) in visibleEvents" :key="index" class="col-md-6 col-sm-6 mb-3">
                                            <div class="upcoming-event">
                                                <p>{{ event.exp_date }}</p>
                                                <span>{{ event.title }}</span>
                                                <div class="learn-btn">
                                                    <a :href="`/event/${event.slug}`">learn more</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="more-news" v-if="events.totalRecords > 6">
                                        <router-link v-bind:to="{name: 'EventDeadlineDetailView'}">View more upcoming events & deadlines ></router-link>
                                    </div>
                                </div>

                                
                            </div>
                            <div class="fs-4 p-4 text-center" v-else>
                                No events
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <button type="button" class="event-button" data-bs-toggle="modal" data-bs-target="#problemModal">
                            <p>Report a problem</p>
                        </button>

                        <div class="modal fade" id="problemModal" tabindex="-1" aria-labelledby="problemModalLabel" aria-hidden="true" data-bs-keyboard="false" data-bs-backdrop="static">
                            <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="problemModalLabel">Report a Problem</h5>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"  @click.prevent="closeModal"></button>
                                    </div>
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="loading-container" style="display: none;">
                                                <div class="loading">
                                                    <img src="/static/images/loading.gif">
                                                </div>
                                            </div>
                                            <div class="col-md-6 form-group pb-10">
                                                <label for="name">Name:</label>
                                                <input @input="nameError=''" type="text" id="name" class="swal2-input" name="name" v-model="problemName" maxlength="190">
                                                <span class="error-message help is-danger">{{ nameError }}</span>
                                            </div>
                                            <div class="col-md-6 form-group pb-10">
                                                <label for="email">Email:</label>
                                                <input @input="emailError=''" type="email" id="email" class="swal2-input" name="email" v-model="problemEmail" maxlength="190">
                                                <span class="error-message help is-danger">{{ emailError }}</span>
                                            </div>
                                            <div class="col-md-12 form-group pb-10">
                                                <label for="phone">Contact No:</label>
                                                <input @input="phoneError=''" type="tel" id="phone" class="swal2-input" name="phone" v-model="problemPhone" maxlength="17">
                                                <span class="error-message help is-danger">{{ phoneError }}</span>
                                            </div>
                                            <div class="col-md-12 form-group pb-10">
                                                <label for="comments">Comment:<span style="color: red">*</span></label>
                                                <textarea @input="commentsError=''" id="comments" class="swal2-textarea" name="comments" v-model="problemComment" maxlength="250" required></textarea>
                                                <span class="error-message help is-danger">{{ commentsError }}</span>
                                            </div>
                                        </div>
                                        <vue-recaptcha
                                            ref="recaptcha"
                                            :sitekey="recaptchaSiteKey"
                                            @verify="verifyCaptcha"
                                            @expired="onCaptchaExpired"
                                        />
                                        <span class="error-message help is-danger">{{ reCAPTCHAError }}</span>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-primary" @click.prevent="report">Send</button>
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click.prevent="closeModal">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button type="button" class="event-button" data-bs-toggle="modal" data-bs-target="#opinionModal">
                            <p>your opinion matters</p>
                        </button>
                        <div class="modal fade" id="opinionModal" tabindex="-1" aria-labelledby="opinionModalLabel" aria-hidden="true" data-bs-keyboard="false" data-bs-backdrop="static">
                            <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="opinionModalLabel">Your Opinion Matters</h5>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"  @click.prevent="closeModal"></button>
                                    </div>
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="loading-container" style="display: none;">
                                                <div class="loading">
                                                    <img src="/static/images/loading.gif">
                                                </div>
                                            </div>
                                            <div class="col-md-6 form-group pb-10">
                                                <label for="type">Type:<span style="color: red">*</span></label>
                                                <select id="type" class="swal2-input" name="type" v-model="opinionType" @change="typeError=''" >
                                                    <option value="feedback">Feedback</option>
                                                    <option value="complaint">Complaint</option>
                                                    <option value="request">Request</option>
                                                    <option value="policy suggestion">Policy suggestion</option>
                                                    <option value="other">Other</option>
                                                </select>
                                                <span id="typeError" class="error-message help is-danger" style="color: red;">{{ typeError }}</span>
                                            </div>
                                            <template v-if="opinionType == 'other'">
                                                <div class="col-md-6 form-group" id="otherField">
                                                    <label for="other">Please specify:<span style="color: red">*</span></label>
                                                    <input @input="otherError=''" type="text" id="other" class="swal2-input" name="other" v-model="opinionOther">
                                                    <span id="otherError" class="error-message help is-danger" style="color: red;">{{ otherError }}</span>
                                                </div>
                                            </template>
                                            <div class="clearfix"></div>
                                            <div class="col-md-6 form-group pb-10">
                                                <label for="name">Name:</label>
                                                <input @input="nameError=''" type="text" id="name" class="swal2-input" name="name" v-model="opinionName" maxlength="190">
                                                <span class="error-message help is-danger" style="color: red;">{{ nameError }}</span>
                                            </div>
                                            <div class="col-md-6 form-group pb-10">
                                                <label for="email">Email:</label>
                                                <input @input="emailError=''" type="email" id="email" class="swal2-input" name="email" v-model="opinionEmail" maxlength="190">
                                                <span class="error-message help is-danger" style="color: red;">{{ emailError }}</span>
                                            </div>
                                            <div class="col-md-12 form-group pb-10">
                                                <label for="phone">Contact No:</label>
                                                <input @input="phoneError=''" type="tel" id="phone" class="swal2-input" name="phone" v-model="opinionPhone" maxlength="17">
                                                <span class="error-message help is-danger" style="color: red;">{{ phoneError }}</span>
                                            </div>
                                            <div class="col-md-12 form-group">
                                                <label for="comments">Comments:<span style="color: red">*</span></label>
                                                <textarea @input="commentsError=''" id="comments" class="swal2-textarea" name="comments" v-model="opinionComment" maxlength="250" required></textarea>
                                                <span class="error-message help is-danger" style="color: red;">{{ commentsError }}</span>
                                            </div>
                                        </div>
                                        <vue-recaptcha
                                            ref="recaptcha"
                                            :sitekey="recaptchaSiteKey"
                                            @verify="verifyCaptcha"
                                            @expired="onCaptchaExpired"
                                        />
                                        <span class="error-message help is-danger" style="color: red;">{{ reCAPTCHAError }}</span>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-primary" @click.prevent="opinion">Send</button>
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click.prevent="closeModal">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a target="_blank" href="https://surveys.velocityvehiclegroup.com/survey/C&Enomination" class="event-button mb-0">
                            <p>nomination for recognition</p>
                        </a>
                    </div>
                </div>    
            </div>
            <div class="resources-section">
                <div class="resources-title">resources</div>
                <div class="row">
                    <div class="col-lg-3 col-6 mb-3">
                        <div class="resoures-detalis">
                            <img src="static/images/resources-img.png" alt="">
                            <div>
                                <a target="_blank" href="https://www.vvguniversity.com">on demand training</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-6 mb-3">
                        <div class="resoures-detalis">
                            <img src="static/images/police-logo.png" alt="">
                            <div>
                                <a href="/policies">policies</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-6 mb-3">
                        <div class="resoures-detalis">
                            <img src="static/images/code-of-conduct.png" alt="">
                            <div>
                                <a href="javascript:void(0)" @click.prevent="loadCodeofConduct">
                                    code of business ethics
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-6 mb-3">
                        <div class="resoures-detalis">
                            <img src="static/images/projects.png" alt="">
                            <div>
                            <a href="/projects">
                                projects
                            </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="team.totalRecords > 0">
                <div class="compliance-title">meet the compliance team</div>
                <div class="row">
                    <div class="col-lg-4 col-md-6 mb-3" v-for="(user, index) in team.row" :key="index">
                        <div class="team-detalis">
                            <img v-if="user.profile_path != ''" :src=user.profile_path alt="" @error="setDefaultImage(index)" :id="'profile-image-' + index">
                            <img v-else src="/static/images/default_user.png" alt="">
                            <div class="">
                                <div class="profile-detail">
                                    <i class="fa fa-user"></i>
                                    <div>{{ user.name }}</div>
                                </div>
                                <div v-if="user.contact_no">
                                    <a :href="'tel:'+ user.contact_no" class="profile-detail">
                                        <i class="fa fa-phone"></i>
                                        <div>{{ user.contact_no }}</div>
                                    </a>
                                </div>
                                <div v-if="user.email">
                                    <a :href="'mailto:' + user.email" class="profile-detail">
                                        <i class="fa fa-envelope"></i>
                                        <div>{{ user.email }}</div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import Swal from 'sweetalert2';
    import EventBus from './event-bus.js';
    import { HTTP } from '../http-common';
    import { commonMixins } from '../mixins/commonMixins';
    import moment from 'moment';
    import timezone from 'moment-timezone';
    import { VueRecaptcha } from 'vue-recaptcha';

    export default {
        name: 'Home',
        mixins: [commonMixins],
        components: { VueRecaptcha },
        data() {
            return {
                news: [],
                events: [],
                team: [],
                recaptchaSiteKey: process.env.RECAPTCHA_SITE_KEY,
                problemName: "",
                problemEmail: "",
                problemPhone: "",
                problemComment: "",
                opinionType: "",
                opinionOther: "",
                opinionName: "",
                opinionEmail: "",
                opinionPhone: "",
                opinionComment: "",
                reCAPTCHAToken: "",
                form: {
                    name: '',
                    email: '',
                    phone: '',
                    comments: '',
                },
                typeError: "",
                otherError: '',
                nameError: '',
                emailError: '',
                phoneError: '',
                commentsError: '',
                reCAPTCHAError: '',
                userId: '',
                codeOfConduct: '',
            }
        },
        computed: {
            visibleEvents() {
                // Return only the first 6 events if not all are to be shown
                return this.events.row.slice(0, 6);
            }
        },
        created: function () {
            var self = this;
            var userObjString = localStorage.getItem('user_obj');
            if (userObjString) {
                var userObj = JSON.parse(userObjString);
                self.userId = userObj.id;
            }
        },
        mounted: function () {
            var self = this;
            self.loadNews();
            self.loadEvents();
            self.loadTeam();
            window.verifyCaptcha = self.verifyCaptcha;
        },
        methods: {
            setDefaultImage(index) {
                $('#profile-image-' + index).attr('src', '/static/images/default_user.png');
            },
            closeModal(){
                var self = this;
                self.problemName= "";
                self.problemEmail= "";
                self.problemPhone= "";
                self.problemComment= "";
                self.opinionType= "";
                self.opinionOther= "";
                self.opinionName= "";
                self.opinionEmail= "";
                self.opinionPhone= "";
                self.opinionComment= "";
                self.reCAPTCHAToken= "";
                self.typeError= '';
                self.otherError= '';
                self.nameError= '';
                self.emailError= '';
                self.phoneError= '';
                self.commentsError= '';
                self.reCAPTCHAError= '';
                $("#problemModal").modal("hide");
                $("#opinionModal").modal("hide");
                if (self.$refs.recaptcha) {
                    var recaptchaWidgetId = self.$refs.recaptcha.reset();
                    if (window.grecaptcha && window.grecaptcha.reset) {
                        window.grecaptcha.reset(recaptchaWidgetId);
                    }
                }
            },
            verifyCaptcha(response) {
                if (response) {
                    this.reCAPTCHAToken = response;
                    this.reCAPTCHAError = '';
                }
            },
            onCaptchaExpired() {
                this.reCAPTCHAToken = '';
            },
            loadNews: function () {
                var self = this;
                var config = {
                    headers: { 'Authorization': 'Bearer ' + localStorage.getItem("tkn") }
                };
                var fields = {
                    'perPage': 4,
                    'tz': moment.tz.guess(),
                }
                HTTP.post("news/list", fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            self.news = response.data.content;
                        }
                    })
                    .catch(function (err) {
                        if (err && err.response && err.response.status) {
                            self.catchHandler(err, function () { });
                        }
                    });
            },
            loadEvents: function () {
                var self = this;
                var config = { headers: { 'Authorization': 'Bearer ' + localStorage.getItem("tkn") } };
                var fields = {
                    'tz': moment.tz.guess(),
                };
                HTTP.post("events/list", fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            self.events = response.data.content;
                        }
                    })
                    .catch(function (err) {
                        if (err && err.response && err.response.status) {
                            self.catchHandler(err, function () { });
                        }
                    });
            },
            loadTeam: function () {
                var self = this;
                var config = { headers: { 'Authorization': 'Bearer ' + localStorage.getItem("tkn") } };
                self.showLoader();
                HTTP.post("complianceteam", {}, config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            self.team = response.data.content;
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        if (err && err.response && err.response.status) {
                            self.catchHandler(err, function () { });
                        }
                    });
            },
            loadCodeofConduct: function () {
                var self = this;

                var config = {
                    params: {
                        'slug': 'code-of-conduct',
                    }
                };
                self.showLoader();
                return HTTP.post("documents/list", {}, config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            const row = response.data.content.row ? response.data.content.row[0] : [];
                            if (row) {
                                if (row.upload_type === 'url') {
                                    self.codeOfConduct = row.url;
                                } else if (row.documents && row.documents[0]) {
                                    self.codeOfConduct = row.documents[0].document;
                                }
                            }
                        }
                        self.hideLoader();
                        
                        if(self.codeOfConduct) {
                            window.open(self.codeOfConduct, '_blank', 'noopener noreferrer');
                        } else {
                            Swal.fire({
                                title: 'Important Announcement!',
                                type: 'info',
                                text: 'Stay tuned! Code of Conduct document will be available soon.',
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                customClass: 'code-of-conduct-model'
                            });
                        }
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(err, function () { });
                        return null;
                    });
            },
            slugFor(page) {
                return page;
            },
            report: function () {
                var self = this;
                var error = false;
                self.nameError = self.emailError = self.phoneError = self.commentsError = self.reCAPTCHAError = '';

                if (self.problemEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(self.problemEmail)) {
                    self.emailError = "Please enter a valid email address.";
                    error = true;
                }
                if(self.problemPhone && !self.validContactNumber(self.problemPhone)) {
                    self.phoneError = "Please enter valid contact number";
                    error = true;
                } else if (self.problemPhone && !self.checkContactNoLength(self.problemPhone)) {
                    self.phoneError = "Max Length is 13";
                    error = true;
                }

                if (self.problemComment == '' || self.problemComment == null || !self.problemComment) {
                    self.commentsError = 'Please enter comment';
                    error = true;
                }
                if (self.reCAPTCHAToken == '' || self.reCAPTCHAToken == null || !self.reCAPTCHAToken) {
                    self.reCAPTCHAError = 'Please verify reCAPTCHA';
                    error = true;
                }

                var fields = {
                    userId: self.userId,
                    name: self.problemName,
                    email: self.problemEmail,
                    phone: self.problemPhone,
                    comments: self.problemComment,
                    recaptchaToken: self.reCAPTCHAToken
                }

                if (!error) {
                    self.showLoader();
                    HTTP.post('problem', fields)
                        .then(function (response) {
                            if (response.data.status == "success") {
                                self.showSAlert("Mail sent successfully", 'success');
                                $("#problemModal").modal("hide");
                                self.problemName= '';
                                self.problemEmail= '';
                                self.problemPhone='';
                                self.problemComment='';
                                self.reCAPTCHAToken='';
                                if (self.$refs.recaptcha) {
                                    var recaptchaWidgetId = self.$refs.recaptcha.reset();
                                    if (window.grecaptcha && window.grecaptcha.reset) {
                                        window.grecaptcha.reset(recaptchaWidgetId);
                                    }
                                }
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            if (err && err.response && err.response.status) {
                                self.catchHandler(err, function () { });
                            }
                        });
                }
                
            },

            opinion: function() {
                var self = this;
                var error = false;
                self.typeError = self.otherError = self.nameError =  self.emailError = self.phoneError = self.commentsError = self.reCAPTCHAError = '';

                if (!self.opinionType) {
                    self.typeError = 'Please select type'
                }
                if (self.opinionType == 'other' && (self.opinionOther == '' || self.opinionOther == null || !self.opinionOther)) {
                    self.otherError = 'Please enter other type'
                }
                if (self.opinionEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(self.opinionEmail)) {
                    self.emailError = "Please enter a valid email address.";
                    error = true;
                }
                if(self.opinionPhone && !self.validContactNumber(self.opinionPhone)) {
                    self.phoneError = "Please enter valid contact number";
                    error = true;
                } else if (self.opinionPhone && !self.checkContactNoLength(self.opinionPhone)) {
                    self.phoneError = "Max Length is 13";
                    error = true;
                }
                if (self.opinionComment == '' || self.opinionComment == null || !self.opinionComment) {
                    self.commentsError = 'Please enter comment';
                    error = true;
                }
                if (self.reCAPTCHAToken == '' || self.reCAPTCHAToken == null || !self.reCAPTCHAToken) {
                    self.reCAPTCHAError = 'Please verify reCAPTCHA';
                    error = true;
                }

                var fields = {
                    userId: self.userId,
                    type: self.opinionType,
                    other: self.opinionOther,
                    name: self.opinionName,
                    email: self.opinionEmail,
                    phone: self.opinionPhone,
                    comments: self.opinionComment,
                    recaptchaToken: self.reCAPTCHAToken
                }

                if (!error) {
                    self.showLoader();
                    HTTP.post('opinion', fields)
                        .then(function (response) {
                            if (response.data.status == "success") {
                                self.showSAlert("Mail sent successfully", 'success');
                                $("#opinionModal").modal("hide");
                                self.opinionType='';
                                self.opinionOther= '';
                                self.opinionName= '';
                                self.opinionEmail= '';
                                self.opinionPhone='';
                                self.opinionComment='';
                                self.reCAPTCHAToken='';
                                if (self.$refs.recaptcha) {
                                    var recaptchaWidgetId = self.$refs.recaptcha.reset();
                                    if (window.grecaptcha && window.grecaptcha.reset) {
                                        window.grecaptcha.reset(recaptchaWidgetId);
                                    }
                                }

                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            self.hideLoader();
                            if (err && err.response && err.response.status) {
                                self.catchHandler(err, function () { });
                            }
                        });
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Home.vue